<template>
  <section>
    <el-dialog
      :title="
        userObj.detail && userObj.detail.id
          ? userObj.isEdit == 1
            ? '修改成员'
            : '查看详情'
          : '新增成员'
      "
      :visible.sync="userObj.dialogVisible"
      width="500px"
      class="addOrEditUser"
      :close-on-click-modal="false"
    >
      <div>
        <el-row type="flex" align="middle" :gutter="10">
          <el-col :span="5"><span>部门：</span></el-col>
          <el-col :span="18">
            <div class="deptSelectResult" @click="initDeptSelect">
              <template v-for="(items, key) in deptListObj.pluginResult.select">
                <template v-for="(item, index) in items">
                  <User :item="item" :key="key + index" :type="key" />
                </template>
              </template>
            </div>
          </el-col>
        </el-row>
        <el-row type="flex" align="middle" :gutter="10">
          <el-col :span="5"><span>成员账号：</span></el-col>
          <el-col :span="18">
            <el-input
              v-model="editUserObj.account"
              placeholder="请输入成员账号"
            ></el-input>
          </el-col>
        </el-row>
        <el-row type="flex" align="middle" :gutter="10">
          <el-col :span="5"><span>成员名字：</span></el-col>
          <el-col :span="18">
            <el-input
              v-model="editUserObj.name"
              placeholder="请输入成员名字"
            ></el-input>
          </el-col>
        </el-row>
        <el-row type="flex" align="middle" :gutter="10">
          <el-col :span="5"><span>成员职位：</span></el-col>
          <el-col :span="18">
            <el-input
              v-model="editUserObj.position"
              placeholder="请输入成员职位"
            ></el-input>
          </el-col>
        </el-row>
        <el-row type="flex" align="middle" :gutter="10">
          <el-col :span="5"><span>固定电话：</span></el-col>
          <el-col :span="18">
            <el-input
              v-model="editUserObj.telephone"
              placeholder="请输入固定电话"
            ></el-input>
          </el-col>
        </el-row>
        <el-row type="flex" align="middle" :gutter="10">
          <el-col :span="5"><span>手机号：</span></el-col>
          <el-col :span="18">
            <el-input
              v-model="editUserObj.mobile"
              placeholder="请输入手机号"
            ></el-input>
          </el-col>
        </el-row>
        <el-row type="flex" align="middle" :gutter="10">
          <el-col :span="5"><span>email：</span></el-col>
          <el-col :span="18">
            <el-input
              v-model="editUserObj.email"
              placeholder="请输入email"
            ></el-input>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button v-if="userObj.isEdit != 0" type="primary" @click="comfire"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <Dept
      :model="deptListObj.model"
      :title="deptListObj.title"
      :visible="deptListObj.visible"
      :selected="deptListObj.pluginResult.select"
      @confirm="deptListObjConfirm"
      @updateVisible="deptListObjUpdateVisible"
    />
  </section>
</template>
<script>
import Dept from "@/components/qyDept/";
import User from "@/components/qyDept/user";
import mixinOrgUrl from "@/components/qyDept/mixinOrgUrl.js";
// import deptUserUrl from "@/components/qyDept/url";
export default {
  props: {
    userObj: {
      type: Object,
      default: () => {
        return {
          dialogVisible: false,
          detail: {}
        };
      }
    }
  },
  data() {
    return {
      editUserObj: {
        department_ids: "",
        account: "",
        name: "",
        position: "",
        telephone: "",
        mobile: "",
        id: ""
      },
      deptListObj: {
        title: "部门选择器",
        model: "org",
        reCreate: false,
        visible: false,
        pluginResult: {
          select: { org: [], group: [], user: [] }
        },
        numberShowPhone: false
      },
      orgUrl: {}
    };
  },
  watch: {},
  components: {
    Dept,
    User
  },
  mixins: [mixinOrgUrl],
  async mounted() {},
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    comfire() {
      let data = {
        department_ids: this.editUserObj.department_ids,
        account: this.editUserObj.account,
        name: this.editUserObj.name,
        position: this.editUserObj.position,
        telephone: this.editUserObj.telephone,
        mobile: this.editUserObj.mobile,
        email: this.editUserObj.email,
        id: this.editUserObj.id
      };
      let department_ids = [];
      this.deptListObj.pluginResult.select.org.forEach(element => {
        department_ids.push(element.id);
      });
      data.department_ids = department_ids;
      this.$common
        .http({
          url: "/api/contact/create_user",
          data: data
        })
        .then(() => {
          this.$common.pcToastSuccess("添加人员成功");
          this.$emit("confirm");
          this.$emit("cancel");
        });
    },
    initDeptSelect() {
      this.deptListObj.reCreate = true;
      this.deptListObj.visible = true;
    },
    deptListObjConfirm(obj) {
      for (let key in obj) {
        this.deptListObj.pluginResult.select[key] = obj[key];
      }
    },
    deptListObjUpdateVisible(val) {
      this.deptListObj.visible = val;
    },
    getinitDeptSelect() {
      console.log("部门初始化数据");
      this.$common
        .http({
          url: this.orgUrl.getInitData,
          data: {
            depts: this.editUserObj.department_ids
          }
        })
        .then(res => {
          let data = res.data.data;
          this.deptListObj.pluginResult.select.org = data.depts;
          this.deptListObj.pluginResult.select.group = data.users;
          this.deptListObj.pluginResult.select.user = data.tags;
        });
    }
  },
  async created() {
    this.orgUrl = await this.mixinOrgUrlSet(1);
    this.editUserObj = {
      department_ids: this.userObj.detail.department_ids || "",
      account: this.userObj.detail.account || "",
      name: this.userObj.detail.name || "",
      position: this.userObj.detail.position || "",
      telephone: this.userObj.detail.telephone || "",
      mobile: this.userObj.detail.mobile || "",
      email: this.userObj.detail.email || "",
      id: this.userObj.detail.id || ""
    };
    if (this.editUserObj.department_ids.length > 0) {
      this.getinitDeptSelect();
    }
  }
};
</script>
<style lang="less" scoped>
.addOrEditUser {
  .el-row {
    padding-bottom: 10px;
  }
  .el-col-5 {
    text-align: right;
  }
  .deptSelectResult {
    box-sizing: border-box;
    height: 32px;
    background: #ffffff;
    border: 1px solid #cecece;
    border-radius: 4px;
  }
}
</style>
